import { useJourneyData } from './useJourneyData';

export const useJourneDataPayload = () => {
  const {
    consumption,
    address,
    hasE7Meter,
    electricVehicle,
    mpan,
    mprn,
    paymentMethod,
    meterType,
    fuelTypeString
  } = useJourneyData();

  return {
    ...(consumption.electric && {
      electricityConsumption: consumption.electric
    }),
    ...(consumption.gas && { gasConsumption: consumption.gas }),
    ...(mpan && { MPAN: mpan }),
    ...(mprn && { MPRN: mprn }),
    postCode: address.postcode,
    meterType,
    economySeven: hasE7Meter,
    EV: !!electricVehicle,
    fuel: fuelTypeString,
    paymentOption: paymentMethod,
    currentAddress: address,
    economySevenMultiRate: false // TODO: to be removed once removed from backend
  };
};
